import { ChangeDetectionStrategy, Component, signal, input, output } from '@angular/core';

import { TaskModel } from '@core/models/task.model';
import { UserModel } from '@core/models/user.model';
import { AvatarComponent } from '@ux/components/avatar/avatar.component';
import { PopupUserComponent } from '@ux/components/select-popup/popup-user/popup-user.component';
import { NgClickOutsideDelayOutsideDirective } from 'ng-click-outside2';

@Component({
  selector: 'app-task-view-followers',
  templateUrl: './task-view-followers.component.html',
  styleUrls: ['./task-view-followers.component.less'],
  imports: [AvatarComponent, PopupUserComponent, NgClickOutsideDelayOutsideDirective],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskViewFollowersComponent {
  protected readonly isOpenPopup = signal<boolean>(false);
  protected readonly onSave = output<string[]>();
  protected readonly task = input<TaskModel>();

  onChangeFollowers(followers: string[]): void {
    const currentTask = this.task();
    if (!currentTask) {
      return;
    }

    this.onSave.emit(followers);
  }

  onClose(): void {
    this.isOpenPopup.set(false);
  }

  onDeleteFollower(user: UserModel): void {
    const currentTask = this.task();
    if (!currentTask) {
      return;
    }

    const followerIndex = currentTask.followers.indexOf(user.id);
    if (followerIndex > -1) {
      const updatedFollowers = [...currentTask.followers];
      updatedFollowers.splice(followerIndex, 1);
      this.onSave.emit(updatedFollowers);
    }
  }

  onToggle(): void {
    this.isOpenPopup.update(currentValue => !currentValue);
  }
}
